import { Injectable } from '@angular/core';
import { DoenKidsGenericApiProvider } from 'src/providers/generic.provider';
import { SortDirection } from '@angular/material/sort';
import { IRangeOfDevelopmentDetailsListResponse } from 'typings/api-activity';
import { RangeOfDevelopmentStore } from './range-of-development.store';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RangeOfDevelopmentService {
  constructor(private store: RangeOfDevelopmentStore, private $baseApi: DoenKidsGenericApiProvider) {}

  async fetchAll(limit: number = 100, skip: number = 0, sortField: string = 'created_at', sortDirection: SortDirection = 'desc') {
    // eslint-disable-next-line max-len
    const rangeOfDevelopmentListRepsonse = await firstValueFrom(this.$baseApi.genericListCall('/activity/range-of-development', limit, skip, sortField, sortDirection)) as IRangeOfDevelopmentDetailsListResponse;

    this.store.set(rangeOfDevelopmentListRepsonse?.items ?? []);
  }
}
